<script setup lang="ts">
const props = defineProps({
	modelValue: {
		type: Boolean,
		default: false
	}
});
defineEmits(["update:modelValue"]);

const uncheckedStateClasses = "border-gray-300";
const checkedStateClasses = "border-violet-600 bg-violet-600";
const checkboxClasses = computed(() => props.modelValue ? checkedStateClasses : uncheckedStateClasses);
</script>

<template>
	<label class="flex items-center cursor-pointer">
		<div class="flex items-center justify-center w-4 h-4 rounded-xs border duration-75" :class="checkboxClasses">
			<NuxtIcon
				v-show="props.modelValue"
				name="check-mini-16"
				class="text-gray-0 text-sm duration-75"
			/>
		</div>
		<span class="ml-2 text-sm select-none">
			<slot></slot>
		</span>
		<input
			type="checkbox"
			class="hidden"
			:checked="modelValue"
			@change="$emit('update:modelValue', ($event.target as any).checked)"
		/>
	</label>
</template>
